import { useEffect } from 'react';
import { useApp } from '@/state/AppContext';
import { adresRegel } from '@/utils/format';
import { SluitIcoon } from '@/components/layout/Iconen';
import { RegistratieFormulier } from './RegistratieFormulier';
import { RegistratieOverzicht } from './RegistratieOverzicht';
import './form.css';

/**
 * Schil om het formulier: bottom sheet op mobiel, zijpaneel op desktop.
 * Sluit met Escape of via de knop; buiten klikken sluit alleen op mobiel,
 * zodat je op desktop de kaart kunt blijven gebruiken.
 */
export function FormulierPaneel(): JSX.Element | null {
  const { actieveRegistratie, geselecteerdeWoning, sluitFormulier, registraties, alleenLezen } =
    useApp();

  useEffect(() => {
    const bijToets = (event: KeyboardEvent) => {
      if (event.key === 'Escape') sluitFormulier();
    };
    document.addEventListener('keydown', bijToets);
    return () => document.removeEventListener('keydown', bijToets);
  }, [sluitFormulier]);

  if (!actieveRegistratie || !geselecteerdeWoning) return null;

  // Nieuw zolang deze registratie nog niet in de opgehaalde lijst voorkomt.
  const isNieuw = !registraties.some((r) => r.id === actieveRegistratie.id);

  return (
    <>
      <div
        className="paneel-overlay"
        onClick={sluitFormulier}
        role="presentation"
        aria-hidden="true"
      />
      <aside
        className="paneel"
        role="dialog"
        aria-modal="false"
        aria-label={`Registratie ${adresRegel(actieveRegistratie.adres)}`}
      >
        <div className="paneel__greep">
          <span />
        </div>

        <header className="paneel__kop">
          <div>
            <div className="paneel__titel">{adresRegel(actieveRegistratie.adres)}</div>
            <div className="paneel__subtitel">
              {actieveRegistratie.adres.postcode} {actieveRegistratie.adres.plaats}
              {' · '}
              {isNieuw ? 'Nog geen registratie' : 'Bestaande registratie'}
            </div>
          </div>
          <button
            type="button"
            className="paneel__sluit"
            onClick={sluitFormulier}
            aria-label="Formulier sluiten"
          >
            <SluitIcoon />
          </button>
        </header>

        {alleenLezen ? (
          isNieuw ? (
            <div className="overzicht__leeg">
              Bij dit adres is nog geen registratie gedaan.
            </div>
          ) : (
            <RegistratieOverzicht key={actieveRegistratie.id} registratie={actieveRegistratie} />
          )
        ) : (
          /* key forceert een schone formulierstaat per woning. */
          <RegistratieFormulier
            key={actieveRegistratie.id}
            registratie={actieveRegistratie}
          isNieuw={isNieuw}
            bijSluiten={sluitFormulier}
          />
        )}
      </aside>
    </>
  );
}
